import { jsx } from 'react/jsx-runtime';
import { Tabs } from '../../Tabs/Tabs.es.js';
import { useTabSwitchContext } from '../TabSwitch.Context/index.es.js';

const TabSwitchTabs = ({ variant, children })=>{
    const { tab } = useTabSwitchContext();
    return jsx(Tabs, {
        current: tab,
        variant: variant,
        children: children
    });
};
TabSwitchTabs.displayName = 'TabSwitch.Tabs';

export { TabSwitchTabs };
//# sourceMappingURL=TabSwitch.Tabs.es.js.map
